import { useToast } from 'primevue/usetoast';
import { logger } from '@logging/logging';

const baseDurationPerCharacter = 75;
const minDuration = 3000;
const maxDuration = 10000;

export const useNotification = () => {
  try {
    const toast = useToast();

    const duration = (message: string) => {
      const calculatedDuration = message.length * baseDurationPerCharacter;
      return Math.max(minDuration, Math.min(calculatedDuration, maxDuration));
    };

    const success = (message: string, indefinite = false) =>
      toast.add({
        severity: 'success',
        detail: message,
        life: indefinite ? undefined : duration(message),
      });

    const error = (message: string) => {
      toast.add({ severity: 'error', detail: message });
    };

    const warning = (message: string) => {
      toast.add({ severity: 'warn', detail: message });
    };

    const info = (message: string, indefinite = false) =>
      toast.add({
        severity: 'info',
        detail: message,
        life: indefinite ? undefined : duration(message),
      });

    return {
      success,
      error,
      warning,
      info,
    };
  } catch (error) {
    // dit komt voor als de notification buiten een setup functie wordt gebruikt.
    logger.warn('Error initializing toast', error);
    return {
      success: (message: string) => console.error('Unsent success toast:', message),
      error: (message: string) => console.error('Unsent error toast:', message),
      warning: (message: string) => console.error('Unsent warning toast:', message),
      info: (message: string) => console.error('Unsent info toast:', message),
    };
  }
};
